import { render } from "./exportPositionProducts.vue?vue&type=template&id=f8509ee2&scoped=true"
import script from "./exportPositionProducts.vue?vue&type=script&lang=js"
export * from "./exportPositionProducts.vue?vue&type=script&lang=js"

import "./exportPositionProducts.vue?vue&type=style&index=0&id=f8509ee2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8509ee2"]])

export default __exports__